import React from 'react'

import {Footer} from './BookingsPortalPage.styled'

import {Typography} from '~/components/general/typography/Typography'

type PartnerLinks = {
  address?: string
  phone?: string
  website?: string
  email?: string
  termsAndConditionsUrl?: string
  privacyPolicyUrl?: string
}

type FooterInfoProps = {
  partner: PartnerLinks
  termsLabel: string
  privacyLabel: string
}

export const FooterInfo: React.FC<FooterInfoProps> = ({
  partner,
  termsLabel,
  privacyLabel,
}) => {
  const items: React.ReactNode[] = []
  const addSep = () =>
    items.length > 0 &&
    items.push(
      <Typography key={`sep-${items.length}`} size="md" color="muted">
        {' | '}
      </Typography>,
    )

  if (partner.address) {
    addSep()
    items.push(
      <Typography key="addr" size="md" color="muted">
        {partner.address}
      </Typography>,
    )
  }
  if (partner.phone) {
    addSep()
    items.push(
      <Typography key="phone" size="md" color="muted">
        {partner.phone}
      </Typography>,
    )
  }
  if (partner.website) {
    addSep()
    items.push(
      <a key="web" href={partner.website} target="_blank" rel="noreferrer">
        <Typography size="md">{partner.website}</Typography>
      </a>,
    )
  }
  if (partner.email) {
    addSep()
    items.push(
      <a key="mail" href={`mailto:${partner.email}`}>
        <Typography size="md">{partner.email}</Typography>
      </a>,
    )
  }
  if (partner.termsAndConditionsUrl) {
    addSep()
    items.push(
      <a
        key="tac"
        href={partner.termsAndConditionsUrl}
        target="_blank"
        rel="noreferrer">
        <Typography size="md">{termsLabel}</Typography>
      </a>,
    )
  }
  if (partner.privacyPolicyUrl) {
    addSep()
    items.push(
      <a
        key="pp"
        href={partner.privacyPolicyUrl}
        target="_blank"
        rel="noreferrer">
        <Typography size="md">{privacyLabel}</Typography>
      </a>,
    )
  }

  return <Footer>{items}</Footer>
}
